import {
  deleteApiJingleCollectionsId,
  getApiJingleCollectionsId,
  postApiJingleCollections,
  putApiJingleCollectionsId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const jingleCollectionByIdQuery = createQuery({
  handler: getApiJingleCollectionsId,
})

export const jingleCollectionCreate = createMutation({
  handler: postApiJingleCollections,
})

export const jingleCollectionUpdate = createMutation({
  handler: putApiJingleCollectionsId,
})

export const jingleCollectionDelete = createMutation({
  handler: deleteApiJingleCollectionsId,
})
